export class ApplicationList {
    public workingym: string
    public date: string
    public empCd: string
    public empNm: string
    public type: string
    public summary: string
    public remarks: string
    public app: string
}
